import { c as _c } from "react/compiler-runtime";
import { useEffect, useSyncExternalStore } from 'react';
import { checkoutProgress, clearCheckoutProgress } from '../checkout/checkout-progress.js';
import { createFundingNavigation } from './navigation.js';
const navigation = new Map();
export function useFundingNavigation(client, t0, purchase) {
  const $ = _c(16);
  const origin = t0 === undefined ? "deposit" : t0;
  let t1;
  if ($[0] !== client.cacheKey || $[1] !== client.progressKey || $[2] !== origin || $[3] !== purchase) {
    t1 = origin === "deposit" ? purchase ? `${client.progressKey ?? client.cacheKey}:${JSON.stringify({
      marketAddress: purchase.marketAddress,
      outcomeIndex: purchase.outcomeIndex,
      ...(purchase.preferredMethod ? {
        preferredMethod: purchase.preferredMethod
      } : {})
    })}` : client.progressKey ?? client.cacheKey : `${client.progressKey ?? client.cacheKey}:withdraw`;
    $[0] = client.cacheKey;
    $[1] = client.progressKey;
    $[2] = origin;
    $[3] = purchase;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const key = t1;
  const now = Date.now();
  let t2;
  if ($[5] !== key) {
    t2 = navigation.get(key);
    $[5] = key;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let entry = t2;
  if (!entry || entry.expiresAt < now) {
    for (const [scope, value] of navigation) {
      if (value.expiresAt < now) {
        navigation.delete(scope);
      }
    }
    if ($[7] !== key || $[8] !== origin || $[9] !== purchase) {
      const base = createFundingNavigation(origin, Boolean(purchase));
      let t3;
      if ($[11] !== key) {
        t3 = () => {
          const progress = checkoutProgress(key);
          progress.method = null;
          progress.amountUnits = null;
          progress.verificationRequested = false;
          progress.verificationFromProfile = false;
          progress.verificationFromLimit = false;
        };
        $[11] = key;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      const clearDraft = t3;
      const controller = {
        ...base,
        deposit: () => {
          clearDraft();
          base.deposit();
        }
      };
      controller.back = () => {
        const revision = base.getSnapshot().revision;
        base.back();
        if (base.getSnapshot().revision !== revision) {
          clearDraft();
        }
      };
      controller.restore = t4 => {
        const retainUnsubmitted = t4 === undefined ? false : t4;
        const revision_0 = base.getSnapshot().revision;
        base.restore(retainUnsubmitted);
        if (base.getSnapshot().revision !== revision_0) {
          clearDraft();
        }
      };
      entry = {
        expiresAt: now + 1800000,
        controller
      };
      navigation.set(key, entry);
      $[7] = key;
      $[8] = origin;
      $[9] = purchase;
      $[10] = entry;
    } else {
      entry = $[10];
    }
  }
  const controller_0 = entry.controller;
  const state = useSyncExternalStore(controller_0.subscribe, controller_0.getSnapshot, controller_0.getSnapshot);
  let t3;
  if ($[13] !== controller_0 || $[14] !== state) {
    t3 = {
      ...state,
      ...controller_0
    };
    $[13] = controller_0;
    $[14] = state;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
/** History uses the same receipt origin rules whether opened from Deposit or a receipt link. */
export function useFundingHistoryNavigation(client, open, initialOperationId, t0) {
  const $ = _c(9);
  const origin = t0 === undefined ? "deposit" : t0;
  const route = useFundingNavigation(client, origin);
  let t1;
  if ($[0] !== initialOperationId || $[1] !== open || $[2] !== route) {
    t1 = () => {
      if (!open) {
        return;
      }
      if (initialOperationId) {
        route.openReceipt(initialOperationId, "history");
      } else {
        route.openHistory();
      }
    };
    $[0] = initialOperationId;
    $[1] = open;
    $[2] = route;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== initialOperationId || $[5] !== open || $[6] !== route.openHistory || $[7] !== route.openReceipt) {
    t2 = [open, initialOperationId, route.openHistory, route.openReceipt];
    $[4] = initialOperationId;
    $[5] = open;
    $[6] = route.openHistory;
    $[7] = route.openReceipt;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  return route;
}
/** Host auth logout hook; ordinary modal teardown deliberately preserves recovery. */
export function clearFundingProgress() {
  clearCheckoutProgress();
  navigation.clear();
}